import React, { forwardRef } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { MoreVertical } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton } from '@lyearn/ui';

const ActionButton = forwardRef<HTMLButtonElement, { className?: string }>((props, ref) => {
  const { t } = useTranslation();

  return (
    <LinkButton
      aria-label={t('Common:ActionMenuButton')}
      {...props}
      ref={ref}
      className={cn(props.className, 'h-36 w-36')}
      color="internal">
      <MoreVertical />
    </LinkButton>
  );
});

export default ActionButton;
